import InvestmentActions from './InvestmentActions';

export default InvestmentActions;
